// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Js_dict = require("bs-platform/lib/js/js_dict.js");
var Js_json = require("bs-platform/lib/js/js_json.js");
var Repo$SF = require("./Repo.bs.js");
var Group$SF = require("./Group.bs.js");
var Utils$SF = require("./Utils.bs.js");
var Belt_List = require("bs-platform/lib/js/belt_List.js");
var Tenant$SF = require("./Tenant.bs.js");
var Project$SF = require("./Project.bs.js");
var Belt_Option = require("bs-platform/lib/js/belt_Option.js");
var Belt_Result = require("bs-platform/lib/js/belt_Result.js");
var Caml_option = require("bs-platform/lib/js/caml_option.js");
var Connection$SF = require("./Connection.bs.js");

function decodeList(jsonDict, key, decoder) {
  var v = Js_dict.get(jsonDict, key);
  if (v === undefined) {
    return {
            TAG: /* Ok */0,
            _0: undefined
          };
  }
  var v$1 = Caml_option.valFromOption(v);
  var rl = Belt_Result.flatMap(Utils$SF.note(Utils$SF.decodeDictName(v$1), Utils$SF.makeError("Invalid value", v$1)), (function (dicts) {
          return Utils$SF.sequenceR(Belt_List.map(dicts, decoder));
        }));
  if (rl.TAG === /* Ok */0) {
    return {
            TAG: /* Ok */0,
            _0: rl._0
          };
  }
  console.log("Could not decode", rl._0);
  return {
          TAG: /* Ok */0,
          _0: undefined
        };
}

function decodeResources(jsonObject, puburl) {
  return Belt_Result.flatMap(decodeList(jsonObject, "projects", Project$SF.decode), (function (projects) {
                return Belt_Result.flatMap(decodeList(jsonObject, "connections", Connection$SF.decode), (function (connections) {
                              return Belt_Result.flatMap(decodeList(jsonObject, "tenants", Tenant$SF.decode), (function (tenants) {
                                            return Belt_Result.flatMap(decodeList(jsonObject, "repos", Repo$SF.decode), (function (repos) {
                                                          return Belt_Result.flatMap(decodeList(jsonObject, "groups", Group$SF.decode), (function (groups) {
                                                                        return {
                                                                                TAG: /* Ok */0,
                                                                                _0: {
                                                                                  projects: projects,
                                                                                  connections: connections,
                                                                                  tenants: tenants,
                                                                                  repos: repos,
                                                                                  groups: groups,
                                                                                  puburl: puburl
                                                                                }
                                                                              };
                                                                      }));
                                                        }));
                                          }));
                            }));
              }));
}

function decode(jsonObject) {
  var error = Utils$SF.makeError("Invalid object", jsonObject);
  return Belt_Result.flatMap(Utils$SF.note(Js_json.decodeObject(jsonObject), error), (function (topDict) {
                return Belt_Result.flatMap(Utils$SF.note(Js_dict.get(topDict, "public-url"), error), (function (v) {
                              return Belt_Result.flatMap(Utils$SF.note(Js_json.decodeString(v), error), (function (puburl) {
                                            return Belt_Result.flatMap(Utils$SF.note(Js_dict.get(topDict, "resources"), error), (function (v) {
                                                          return Belt_Result.flatMap(Utils$SF.note(Js_json.decodeObject(v), error), (function (resDict) {
                                                                        return decodeResources(resDict, puburl);
                                                                      }));
                                                        }));
                                          }));
                            }));
              }));
}

function listToJsonDict(xs, encoder) {
  return Js_dict.fromList(Belt_List.flatten(Belt_Option.getExn(Utils$SF.sequence(Belt_List.map(Belt_Option.getExn(Utils$SF.sequence(Belt_List.map(Belt_List.map(xs, encoder), Utils$SF.encodeDictName))), (function (x) {
                                return Belt_Option.flatMap(Js_json.decodeObject(x), (function (dict) {
                                              return Belt_List.fromArray(Js_dict.entries(dict));
                                            }));
                              }))))));
}

function optionalListToJsonDict(oxs, encoder) {
  if (oxs !== undefined) {
    return listToJsonDict(oxs, encoder);
  } else {
    return null;
  }
}

function encode(resources) {
  return Js_dict.fromList({
              hd: [
                "public-url",
                resources.puburl
              ],
              tl: {
                hd: [
                  "resources",
                  Js_dict.fromList(Belt_List.keep({
                            hd: [
                              "connections",
                              optionalListToJsonDict(resources.connections, Connection$SF.encode)
                            ],
                            tl: {
                              hd: [
                                "groups",
                                optionalListToJsonDict(resources.groups, Group$SF.encode)
                              ],
                              tl: {
                                hd: [
                                  "projects",
                                  optionalListToJsonDict(resources.projects, Project$SF.encode)
                                ],
                                tl: {
                                  hd: [
                                    "repos",
                                    optionalListToJsonDict(resources.repos, Repo$SF.encode)
                                  ],
                                  tl: {
                                    hd: [
                                      "tenants",
                                      optionalListToJsonDict(resources.tenants, Tenant$SF.encode)
                                    ],
                                    tl: /* [] */0
                                  }
                                }
                              }
                            }
                          }, (function (param) {
                              return !Utils$SF.isNull(param[1]);
                            })))
                ],
                tl: /* [] */0
              }
            });
}

exports.decodeList = decodeList;
exports.decodeResources = decodeResources;
exports.decode = decode;
exports.listToJsonDict = listToJsonDict;
exports.optionalListToJsonDict = optionalListToJsonDict;
exports.encode = encode;
/* No side effect */
